// extracted by mini-css-extract-plugin
module.exports = {"brandImage":"ProductBrandAccordion_brandImage__4QL__","productBrand":"ProductBrandAccordion_productBrand__X4Odm"};